module.exports = __webpack_public_path__ + "img/svgexport-6.76506b58.svg";